import React from 'react';
import Image from "next/image";

const loadingComponent = () => {
    return (
        <div className="loading" id="loading">
            {/* <svg viewBox="0 0 4500 4500" className="loading-enable-background">
                <g>
                    <path className="st0" d="M3742.9,2064.5c-99.9,0-199.7,1.5-299.6-0.7c-41.7-0.9-58,13.2-57,55.5c2,86.3,3.1,172.8-0.4,259
		        c-2,49,18.8,57.8,62,57.4c191.6-1.8,383.2,0.7,574.8-1.7c52-0.6,66.1,8.5,59.5,66.8C3993,3294,3309.1,3985.8,2513,4084
		        c-805,99.3-1559.1-294.1-1900.5-1026c-328-703-245.7-1377.7,240.4-1985.5c358-447.5,840.6-667.2,1411.2-671.7
		        c739.2-5.7,1418,462,1696.8,1149.9c60.1,148.2,99.3,301.3,122.2,459.5c6.7,46.2-6.5,55.8-48.6,54.9
		        C3937.3,2063,3840.1,2064.5,3742.9,2064.5z M2277.2,3330.6c464.6-9.5,725.6-322.5,828.4-656.2c12.4-40.2,28.2-79.6-37.4-101.2
		        c-62.3-20.4-74.1,12.5-92.5,54.8c-192.6,444.3-795.1,535.5-1114.5,170.1c-167.6-191.7-229.5-421.8-254.9-667.7
		        c-6.1-59.1,3.8-86.3,68.6-95.4c218.6-30.7,436.4-67.4,654.4-102.1c167.5-26.7,335.2-52.8,502.4-81.5c58.7-10.1,114.4-30,97.8-108.8
		        c-46.8-222.7-239.4-530.1-540.6-586.1c-375.8-69.9-861.8,87.2-1049.1,555.9c-172,430.3-105.1,844.3,135.1,1227.2
		        C1657.7,3231.1,1936.8,3357.2,2277.2,3330.6z"/>
                    <path className="st1" d="M2084.3,1305.5c251.9,4.5,362.8,206.7,390.2,377.6c10.7,66.7-45.9,79.6-93.1,88
		        c-161.6,28.7-323.8,54.2-485.9,80.2c-82.4,13.3-165.1,24.5-247.4,38.2c-26.4,4.4-49.3,12-43.1-30
		        c29.3-197.6,88.2-378.4,271.5-490.9C1944.9,1326.6,2019.8,1309,2084.3,1305.5z"/>
                </g>
            </svg> */}
            <Image
                src={`/img/loading.gif`}
                width={100}
                height={100}
                alt="f1soft"
                />
        </div>
    )
}

export default loadingComponent
